"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TableHeader_1 = __importDefault(require("./TableHeader"));
var Prizes_1 = __importDefault(require("./Prizes"));
var Rules_1 = __importDefault(require("./Rules"));
var LeaderBoard_1 = __importDefault(require("./LeaderBoard"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var prepareRewards_1 = __importDefault(require("./prepareRewards"));
var TableResultsAndPrizesWithTabsAndRows = function (_a) {
    var _b;
    var id = _a.id, baseTournament = _a.baseTournament, isFinished = _a.isFinished, endDate = _a.endDate, me = _a.me, topScores = _a.topScores;
    var _c = (0, react_1.useState)(0), activeTab = _c[0], setActiveTab = _c[1];
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var loyaltyBonuses = (0, swr_hooks_1.useLoyaltyBonuses)().data;
    var isFinishedByDate = (0, react_1.useMemo)(function () { return (endDate ? new Date(endDate) < new Date() : false); }, [endDate]);
    var preparedRewards = (0, react_1.useMemo)(function () {
        var _a;
        var sortedRewards = (_a = baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.rewards) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) { return (a.position || 0) - (b.position || 0); });
        return (0, prepareRewards_1.default)({
            rewards: sortedRewards || [],
            currency: currentCurrency,
            bonuses: loyaltyBonuses,
        });
    }, [baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.rewards, loyaltyBonuses, currentCurrency]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(TableHeader_1.default, { activeTab: activeTab, onClickHandler: setActiveTab }),
        activeTab === 0 && (react_1.default.createElement(LeaderBoard_1.default, { isFinished: isFinished || isFinishedByDate, tournamentPosition: me, rewards: preparedRewards, topScores: topScores })),
        activeTab === 1 && (react_1.default.createElement(Prizes_1.default, { rewards: preparedRewards, userConfirmed: !!me, tournamentId: id, isFinished: isFinished || isFinishedByDate })),
        activeTab === 2 && (react_1.default.createElement(Rules_1.default, { description: translateLocale((_b = baseTournament === null || baseTournament === void 0 ? void 0 : baseTournament.descriptions) === null || _b === void 0 ? void 0 : _b.long), bottomContent: react_1.default.createElement(Prizes_1.default, { rewards: preparedRewards, userConfirmed: !!me, tournamentId: id, isFinished: isFinished || isFinishedByDate }) }))));
};
exports.default = TableResultsAndPrizesWithTabsAndRows;
